export const getScoreLabel = (score) => {
  return score < 4 ? '나쁨' : (score < 6 ? '그럭저럭' : (score < 9 ? '우수함' : '최고'))
}
